import { useNavigate } from "react-router-dom";
import styles from "./demandViewer.module.css"
const DemandViewer = () => {
    const navigate = useNavigate();
    const goto = () => {
        navigate("/connectivity/demandToCashDetail/12333212")
    }
    return(
        <>
        <div className={styles.demandheader}>Demand List page</div>
        <span className={styles.goto} onClick={goto}>click here</span>
        </>
    )
};

export default DemandViewer;